import { RootRoute, rootRouteData } from '@app/const';

/** Re-render the page used for @see route if it is the active route. */
export function renderByRoute(route: RootRoute): void {
  const { basePath } = rootRouteData[route] ?? {};
  if (basePath && window.location.pathname.startsWith(basePath)) {
    window.apm.reactDOMComponents.render(route);
  }
}
